import { IWorkflowInput, WorkflowAvatarValue } from "@/interfaces/workflow.interface";
import { buildWorkflowUpdatePayload } from "@/utils/workflow-update-payload";

export const AVATAR_ACCEPTED_TYPES = ["image/png"];

export type WorkflowFormValues = IWorkflowInput & {
  avatar: WorkflowAvatarValue;
};

export const buildWorkflowFormInitialData = (
  workflow?: IWorkflowInput | null
): WorkflowFormValues => {
  return {
    name: workflow?.name || "",
    description: workflow?.description || "",
    displayName: workflow?.displayName || "",
    active: workflow?.active ?? false,
    workflowTypeId: workflow?.workflowTypeId || 1,
    avatar: workflow?.avatarUrl || null,
  };
};

export const hasAvatarChanged = (
  avatar: WorkflowAvatarValue,
  existingWorkflow?: IWorkflowInput | null
): boolean => {
  if (avatar instanceof File) return true;
  return !avatar && !!existingWorkflow?.avatarMidiaId;
};

export const normalizeWorkflowFormData = (
  formData: IWorkflowInput,
  existingWorkflow?: IWorkflowInput | null
): IWorkflowInput => {
  if (!existingWorkflow) {
    return {
      name: formData.name || "",
      description: formData.description || "",
      displayName: formData.displayName || "",
      active: formData.active ?? false,
      workflowTypeId: formData.workflowTypeId || 1,
      productDisplayType: "LIST",
    };
  }

  const existing = existingWorkflow as Record<string, unknown>;
  const fromForm = formData.productDisplayType;
  const fromExisting = existing.productDisplayType ?? existing.ProductDisplayType;
  const normalizedType = String(fromForm ?? fromExisting ?? "LIST").toUpperCase();

  return buildWorkflowUpdatePayload(existingWorkflow, {
    name: formData.name || "",
    description: formData.description || "",
    displayName: formData.displayName || "",
    active: formData.active ?? false,
    workflowTypeId: formData.workflowTypeId || 1,
    productDisplayType: normalizedType === "CAROUSEL" ? "CAROUSEL" : "LIST",
  });
};
